import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Separate axios instance for auth - no redirect interceptor
const authApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' }
});

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const res = await authApi.get('/auth/me', {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(res.data.user);
        } catch {
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password) => {
    const res = await authApi.post('/auth/login', { email, password });
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const sendOTP = async (email) => {
    const res = await authApi.post('/auth/send-otp', { email });
    return res.data;
  };

  const verifyOTP = async (email, otp) => {
    const res = await authApi.post('/auth/verify-otp', { email, otp });
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const forgotPassword = async (email) => {
    const res = await authApi.post('/auth/forgot-password', { email });
    return res.data;
  };

  const resetPasswordWithOTP = async (email, otp, password) => {
    const res = await authApi.post('/auth/reset-password-otp', { email, otp, password });
    return res.data;
  };

  const logout = async () => {
    try { await authApi.post('/auth/logout'); } catch {}
    localStorage.removeItem('token');
    setUser(null);
    window.location.href = '/admin/login';
  };

  const updateProfile = async (data) => {
    const res = await authApi.put('/auth/profile', data);
    setUser(res.data.user);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateProfile, sendOTP, verifyOTP, forgotPassword, resetPasswordWithOTP, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
